import React from 'react';
import { motion } from 'motion/react';

export default function GirlWhoCouldTasteLiesCover() {
  return (
    <div className="absolute inset-0 w-full h-full overflow-hidden select-none bg-indigo-50 font-sans shadow-inner">
      {/* Background: School Locker Hallway with greyish-blue lockers in perspective */}
      <div className="absolute inset-0 w-full h-full bg-gradient-to-b from-[#b4d2e7] via-[#c9dbe9] to-[#d6e5ef]">
        
        {/* Perspectival Locker Lines / Layout */}
        <svg viewBox="0 0 100 133" className="absolute inset-0 w-full h-full text-[#9cbcd2]/40 fill-none stroke-current stroke-[0.8] z-5">
          {/* Floor & Wall horizon line */}
          <line x1="0" y1="95" x2="100" y2="95" strokeWidth="1.5" />
          
          {/* Left Wall Locker Perspective */}
          <path d="M 0 5 L 42 45 L 42 95 L 0 115" fill="#a4c2d6/20" />
          <line x1="12" y1="16" x2="12" y2="98" />
          <line x1="24" y1="28" x2="24" y2="96" />
          <line x1="34" y1="38" x2="34" y2="95" />
          
          {/* Locker Ventilation Slits (Left) */}
          <line x1="4" y1="20" x2="8" y2="18" strokeWidth="1" />
          <line x1="4" y1="24" x2="8" y2="22" strokeWidth="1" />
          <line x1="16" y1="34" x2="20" y2="32" strokeWidth="1" />
          <line x1="16" y1="38" x2="20" y2="36" strokeWidth="1" />

          {/* Right Wall Locker Perspective */}
          <path d="M 100 5 L 58 45 L 58 95 L 100 115" fill="#a4c2d6/20" />
          <line x1="88" y1="16" x2="88" y2="98" />
          <line x1="76" y1="28" x2="76" y2="96" />
          <line x1="66" y1="38" x2="66" y2="95" />

          {/* Locker Ventilation Slits (Right) */}
          <line x1="96" y1="20" x2="92" y2="18" strokeWidth="1" />
          <line x1="96" y1="24" x2="92" y2="22" strokeWidth="1" />
          <line x1="84" y1="34" x2="80" y2="32" strokeWidth="1" />
          <line x1="84" y1="38" x2="80" y2="36" strokeWidth="1" />
        </svg>

        {/* Foreground characters representing Maya Miller (disgusted) and Toby (happy with sandwich) */}
        <div className="absolute inset-x-0 bottom-0 h-[62%] z-15 flex justify-between items-end px-3">
          
          {/* Left Character: Maya Miller (revolted, brown hair, purple backpack strap) */}
          <div className="relative w-[42%] h-[78%]">
            <svg viewBox="0 0 100 100" className="absolute bottom-[-1px] left-0 w-full h-full fill-current">
              {/* Torso: Purple shirt with backpack strap */}
              <path d="M 10 100 L 90 100 L 80 75 C 75 66 65 62 50 62 C 35 62 25 66 20 75 Z" fill="#6d28d9" />
              <path d="M 28 72 Q 40 76 40 100" stroke="#f472b6" strokeWidth="4.5" fill="none" /> {/* pink straps */}
              <path d="M 72 72 Q 60 76 60 100" stroke="#f472b6" strokeWidth="4.5" fill="none" />

              {/* Neck */}
              <rect x="44" y="52" width="12" height="12" fill="#fed7aa" />

              {/* Head / Ears */}
              <ellipse cx="50" cy="42" rx="18" ry="18" fill="#fed7aa" />
              <circle cx="31" cy="42" r="4.5" fill="#fed7aa" />
              <circle cx="69" cy="42" r="4.5" fill="#fed7aa" />

              {/* Hair (Short brown with active bangs) */}
              <path d="M 26 42 Q 24 24 50 16 Q 76 24 74 42 C 78 35 76 22 64 18 C 52 14 42 16 34 18 C 24 22 22 35 26 42 Z" fill="#78350f" />
              <path d="M 28 32 C 36 26 42 35 48 30 C 54 36 65 24 72 32" stroke="#78350f" strokeWidth="3" fill="none" />

              {/* Restricted/Revolted Angry Eyes */}
              <path d="M 36 40 L 46 44" stroke="#451a03" strokeWidth="2.5" />
              <path d="M 64 40 L 54 44" stroke="#451a03" strokeWidth="2.5" />
              <circle cx="41" cy="45" r="2.2" fill="#1e1b4b" />
              <circle cx="59" cy="45" r="2.2" fill="#1e1b4b" />

              {/* Tongue looking grossed out / open mouth */}
              <path d="M 44 54 Q 50 62 56 54 Z" fill="#451a03" />
              {/* Green/Gross tongue sticking out represent disgust */}
              <path d="M 47 56 Q 50 66 53 56 Z" fill="#b91c1c" />
              
              {/* Unhappy squiggly mouth profile */}
              <path d="M 41 51 Q 50 48 59 52" stroke="#451a03" strokeWidth="2" fill="none" />
              <path d="M 43 36 L 49 38" stroke="#78350f" strokeWidth="1.5" /> {/* angry brows */}
              <path d="M 57 36 L 51 38" stroke="#78350f" strokeWidth="1.5" />
            </svg>
          </div>

          {/* Right Character: Toby (Smiling blonde kid in a red shirt, munching a sandwich) */}
          <div className="relative w-[38%] h-[74%]">
            <svg viewBox="0 0 100 100" className="absolute bottom-[-1px] right-0 w-full h-full fill-current">
              {/* Torso: Red shirt */}
              <path d="M 15 100 L 85 100 L 78 72 C 72 65 62 60 50 60 C 38 60 28 65 22 72 Z" fill="#dc2626" />
              
              {/* Neck */}
              <rect x="45" y="52" width="10" height="10" fill="#fed7aa" />

              {/* Head */}
              <ellipse cx="50" cy="42" rx="16" ry="16" fill="#fed7aa" />
              
              {/* Hair: Messy spiky bright gold blond */}
              <path d="M 30 36 C 28 20 40 12 50 12 C 60 12 72 20 70 36" fill="#eab308" />
              <path d="M 32 32 L 35 24 L 40 28 L 45 18 L 50 25 L 55 16 L 60 25 L 65 20 L 68 30 Z" fill="#eab308" />

              {/* Happy closed cartoon eyes */}
              <path d="M 35 44 Q 40 40 45 44" stroke="#451a03" strokeWidth="2" fill="none" />
              <path d="M 55 44 Q 60 40 65 44" stroke="#451a03" strokeWidth="2" fill="none" />

              {/* Cheek lines and extremely wide happy smile */}
              <path d="M 36 50 Q 50 62 64 50" stroke="#451a03" strokeWidth="2.5" fill="none" />
              {/* Cheek circles */}
              <circle cx="34" cy="48" r="2.5" fill="#f87171" opacity="0.5" />
              <circle cx="66" cy="48" r="2.5" fill="#f87171" opacity="0.5" />

              {/* Small Sandwich outline near mouth */}
              <path d="M 40 54 L 60 54 L 56 64 L 44 64 Z" fill="#fef08a" /> {/* Bread crust / yellow cheese fill */}
              <rect x="42" y="56" width="16" height="3" fill="#15803d" /> {/* Lettuce */}
              <rect x="42" y="59" width="16" height="4" fill="#a16207" /> {/* Peanut butter */}
            </svg>
          </div>
        </div>

        {/* Central Giant Waving Swirl Smoke Cloud of disgusting tastes */}
        <div className="absolute inset-x-0 top-[22%] bottom-[12%] z-10 flex items-center justify-center pointer-events-none">
          <motion.div 
            className="relative w-64 h-56"
            animate={{
              y: [0, -6, 0],
              scale: [1, 1.02, 1]
            }}
            transition={{
              duration: 4.5,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          >
            {/* The main puffy purple shadow-like cloud shape represent lies */}
            <svg 
              viewBox="0 0 200 180" 
              className="absolute inset-x-0 top-0 w-full h-full text-purple-200/90 hover:text-purple-300 fill-current filter drop-shadow-[0_8px_16px_rgba(147,51,234,0.18)]"
            >
              <path d="M 40 100 
                       A 30 30 0 0 1 80 50 
                       A 35 35 0 0 1 140 40 
                       A 35 35 0 0 1 175 90 
                       A 30 30 0 0 1 145 150 
                       A 35 35 0 0 1 85 145 
                       A 30 30 0 0 1 40 100 Z" />
              
              {/* Extra cute inner detail lines */}
              <path d="M 65 65 A 15 15 0 0 1 95 62" stroke="#a78bfa" strokeWidth="2" fill="none" opacity="0.5" />
              <path d="M 115 135 A 20 20 0 0 1 145 115" stroke="#a78bfa" strokeWidth="2" fill="none" opacity="0.5" />
            </svg>

            {/* FLOATING AND SPINNING ITEMS INSIDE THE SMOKE CLOUD */}
            
            {/* Icon 1: Dark Brown Burnt Toast Slice */}
            <motion.div 
              className="absolute left-[15%] top-[25%] w-14 h-14"
              animate={{ rotate: [-8, 8, -8], y: [0, -4, 0] }}
              transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
            >
              <svg viewBox="0 0 40 40" className="w-full h-full filter drop-shadow-[0_2px_4px_rgba(0,0,0,0.25)]">
                {/* Outer dark brown crust */}
                <path d="M 6 12 C 6 6, 12 5, 20 8 C 28 5, 34 6, 34 12 L 32 34 rx=2 C 22 35, 18 35, 8 34 Z" fill="#3b2314" />
                {/* Inner black face representing heavily charred / burnt */}
                <path d="M 9 14 C 11 10, 15 10, 20 12 C 25 10, 29 10, 31 14 L 29 31 C 20 32, 18 32, 11 31 Z" fill="#18181b" />
                {/* Small white smoke squiggly lines */}
                <path d="M 14 6 C 14 3, 16 3, 16 1" stroke="#ffffff" strokeWidth="1" fill="none" />
                <path d="M 24 7 C 24 4, 26 4, 26 2" stroke="#ffffff" strokeWidth="1" fill="none" />
              </svg>
            </motion.div>

            {/* Icon 2: Heavy Black Rubber Car Tire */}
            <motion.div 
              className="absolute right-[14%] top-[22%] w-14 h-14"
              animate={{ rotate: [360, 0], y: [0, 3, 0] }}
              transition={{ duration: 7, repeat: Infinity, ease: "linear" }}
            >
              <svg viewBox="0 0 40 40" className="w-full h-full filter drop-shadow-[0_2px_4px_rgba(0,0,0,0.25)]">
                {/* Outer Black Tire body */}
                <circle cx="20" cy="20" r="16" fill="#1e1e24" />
                {/* Shading ring */}
                <circle cx="20" cy="20" r="14" fill="#09090b" />
                {/* Inner open rim */}
                <circle cx="20" cy="20" r="8" fill="#bcafb8" opacity="0.8" />
                {/* Tread marks spokes */}
                <line x1="20" y1="4" x2="20" y2="8" stroke="#374151" strokeWidth="2" />
                <line x1="20" y1="32" x2="20" y2="36" stroke="#374151" strokeWidth="2" />
                <line x1="4" y1="20" x2="8" y2="20" stroke="#374151" strokeWidth="2" />
                <line x1="32" y1="20" x2="36" y2="20" stroke="#374151" strokeWidth="2" />
              </svg>
            </motion.div>

            {/* Icon 3: Cracked Rotten Egg with bright yellow yolk oozing */}
            <motion.div 
              className="absolute left-[24%] bottom-[15%] w-14 h-12"
              animate={{ y: [0, -5, 0], rotate: [5, -5, 5] }}
              transition={{ duration: 3.5, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
            >
              <svg viewBox="0 0 40 32" className="w-full h-full filter drop-shadow-[0_3px_5px_rgba(0,0,0,0.2)]">
                {/* Spilled egg white pooling */}
                <ellipse cx="20" cy="20" rx="16" ry="10" fill="#f8fafc" opacity="0.9" />
                {/* Glowing sulfur yellow yolk */}
                <circle cx="18" cy="18" r="6" fill="#eab308" />
                {/* Broken white eggshells pointing out */}
                <path d="M 6 12 L 14 10 L 8 20 Z" fill="#e2e8f0" stroke="#cbd5e1" strokeWidth="0.8" />
                <path d="M 34 14 L 28 12 L 32 24 L 30 14 Z" fill="#e2e8f0" stroke="#cbd5e1" strokeWidth="0.8" />
              </svg>
            </motion.div>

            {/* Icon 4: Gross Chicken Drumstick Bone */}
            <motion.div 
              className="absolute right-[22%] bottom-[16%] w-12 h-12"
              animate={{ rotate: [-10, 10, -10], scale: [0.95, 1.05, 0.95] }}
              transition={{ duration: 4, repeat: Infinity, ease: "easeInOut", delay: 1 }}
            >
              <svg viewBox="0 0 40 40" className="w-full h-full filter drop-shadow-[0_3px_5px_rgba(0,0,0,0.2)]">
                {/* Roasted golden meat with bite taken or simple bone */}
                <path d="M 12 14 L 30 32" stroke="#ebd2c4" strokeWidth="6" strokeLinecap="round" />
                <circle cx="32" cy="32" r="4.5" fill="#f5ebe6" />
                <circle cx="28" cy="34" r="4.5" fill="#f5ebe6" />
                {/* Big cooked piece of smelly green/brown food at end */}
                <path d="M 8 10 C 6 4, 18 2, 22 10 C 24 14, 16 22, 10 16 Z" fill="#713f12" />
                {/* Small green odor lines */}
                <path d="M 10 2 C 10 0, 12 -1, 10 -3" stroke="#22c55e" strokeWidth="1" fill="none" opacity="0.7" />
              </svg>
            </motion.div>
          </motion.div>
        </div>
      </div>

      {/* OVERLAY TITLE & AUTHOR BLOCK */}
      <div className="absolute inset-0 flex flex-col items-center justify-between p-7 text-center z-35 pointer-events-none">
        
        {/* Playful Colorful Header */}
        <div className="w-full flex flex-col items-center mt-2">
          {/* THE tag */}
          <span className="text-purple-600 font-sans font-bold text-[10px] sm:text-xs tracking-[0.25em] uppercase mb-0.5 drop-shadow-[0_1px_1px_rgba(255,255,255,0.8)]">
            THE
          </span>
          
          {/* Bubble Title layout */}
          <h1 
            className="font-sans font-black text-xl sm:text-2.2xl md:text-3xl text-purple-900 leading-none uppercase select-none tracking-tight font-extrabold"
            style={{
              textShadow: '0 2px 4px rgba(255, 255, 255, 1), 0 0 10px rgba(168, 85, 247, 0.25)',
            }}
          >
            GIRL WHO COULD<br />
            <span className="text-emerald-700">TASTE LIES</span>
          </h1>
        </div>

        {/* Bottom Author block */}
        <div className="mb-2">
          <span 
            className="text-purple-900/90 font-mono text-[9px] sm:text-[11px] font-bold tracking-[0.16em] uppercase drop-shadow-[0_1px_1px_rgba(255,255,255,0.8)]"
          >
            By Cian Zaki
          </span>
        </div>
      </div>

      {/* Soft overlay gradient */}
      <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-[#cfebf3]/10 to-transparent z-25" />
    </div>
  );
}
